import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { entraService, peopleService } from '../../services/api';

export default function PersonIdentityTab({ person, summary: summaryProp, onChanged }){
  const personId = person?.Id ?? person?.id;
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [linked, setLinked] = useState(summaryProp?.appUser || null);
  const [confirm, setConfirm] = useState(null); // { objectId, displayName, email }
  const [page, setPage] = useState(0);

  useEffect(()=>{
    // Sync from parent-provided summary when available
    setLinked(summaryProp?.appUser || null);
  }, [summaryProp]);

  // Remove heavy preload; use type-ahead search instead
  const [query, setQuery] = useState('');
  useEffect(()=>{
    let active = true;
    if(linked || !query || query.trim().length < 2){ setResults([]); return; }
    setLoading(true);
    const h = setTimeout(async ()=>{
      try {
        const users = await entraService.searchUsers(query.trim(), 20);
        if(active) setResults(users||[]);
      } catch { if(active) setResults([]); }
      finally { if(active) setLoading(false); }
    }, 300);
    return ()=>{ active = false; clearTimeout(h); };
  }, [query, linked]);




  const doLink = async ()=>{
    if(!confirm || !personId) return;
    try{
      await entraService.link({ personId, objectId: confirm.objectId, email: confirm.email, displayName: confirm.displayName });
      setLinked({ AzureAdObjectId: confirm.objectId, Email: confirm.email, DisplayName: confirm.displayName });
      setConfirm(null);
      onChanged?.();
    } catch(e){}
  };

  const doUnlink = async ()=>{
    if(!personId) return;
    try{
      await entraService.unlink(personId);
      setLinked(null);
      onChanged?.();
    } catch(e){}
  };

  if(!personId) return <Typography variant="body2" color="text.secondary">Select a person first.</Typography>;

  if(linked){
    return (
      <Box>
        <Typography variant="subtitle2" sx={{ mb:1 }}>Linked Entra account</Typography>
        <Stack direction="row" spacing={2} sx={{ mb:1 }}>
          <Box>
            <Typography variant="body2"><b>Display Name:</b> {linked.DisplayName || linked.displayName}</Typography>
            <Typography variant="body2"><b>Email:</b> {linked.Email || linked.email}</Typography>
            <Typography variant="body2"><b>ObjectId:</b> {linked.AzureAdObjectId || linked.azureAdObjectId}</Typography>
          </Box>
        </Stack>
        <Button variant="outlined" color="warning" size="small" onClick={doUnlink}>Unlink</Button>
      </Box>
    );
  }
  return (
    <>

    <Box>
      <Box sx={{ display:'flex', gap:1, alignItems:'center', mb:1 }}>
        <Typography variant="body2">Search Entra:</Typography>
        <input value={query} onChange={(e)=> setQuery(e.target.value)} placeholder="name or email" style={{ flex:1, padding:'6px 8px' }} />
        {loading && <Typography variant="caption" color="text.secondary">Loading…</Typography>}
      </Box>
      <Table size="small" sx={{ tableLayout:'fixed', '& th, & td': { py:0.5, whiteSpace:'nowrap' } }}>
        <TableHead>
          <TableRow>
            <TableCell>Display Name</TableCell>
            <TableCell>Email / UPN</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(results||[]).slice(page*10, page*10+10).map(u => (
            <TableRow key={u.ObjectId || u.objectId}>
              <TableCell>
                <Button size="small" variant="text" sx={{ p:0, minWidth:0, textTransform:'none' }} onClick={()=> setConfirm({ objectId: u.ObjectId || u.objectId, displayName: u.DisplayName || u.displayName, email: u.Email || u.email })}>
                  {u.DisplayName || u.displayName}
                </Button>
              </TableCell>
              <TableCell>{u.Email || u.email}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Stack direction="row" spacing={1} sx={{ mt:1 }}>
        <Button size="small" disabled={page===0} onClick={()=> setPage(p=>Math.max(0,p-1))}>Prev</Button>
        <Typography variant="caption" sx={{ lineHeight:2.5 }}>Page {page+1}</Typography>
        <Button size="small" disabled={(page+1)*10 >= (results?.length||0)} onClick={()=> setPage(p=>p+1)}>Next</Button>
        <Box sx={{ flex:1 }} />
        <Typography variant="caption" color="text.secondary">{results?.length||0} results</Typography>
      </Stack>

      <Dialog open={!!confirm} onClose={()=>setConfirm(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Link Entra account</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb:1 }}>This will link the selected Entra account to the current Person. Are you sure?</Typography>
          <Typography variant="body2"><b>Person ID:</b> {personId}</Typography>
          <Typography variant="body2"><b>Display Name:</b> {confirm?.displayName}</Typography>
          <Typography variant="body2"><b>Email:</b> {confirm?.email}</Typography>
          <Typography variant="body2"><b>ObjectId:</b> {confirm?.objectId}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setConfirm(null)} size="small">Cancel</Button>
          <Button onClick={doLink} variant="contained" size="small">Confirm link</Button>
        </DialogActions>
      </Dialog>
    </Box>
    </>
  );
}

